import { forceVisible } from 'react-lazyload';
// Store
import { useDispatch, useSelector } from 'react-redux';
// Actions
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectFilter } from 'app/store/page/page.selectors';
// Components
import ColorPalette from 'app/components/ColorPalette';
import { PagesToolbarActions } from 'app/store/pagesToolbar/pagesToolbar.slice';

const ColorsPicker = () => {
  // Dispatch
  const dispatch = useDispatch();
  // State
  const trialMode = useSelector(selectTrialMode);
  const filter = useSelector(selectFilter);

  const handleClick = (newColor:string) => () => {
    const idx = filter.colors.indexOf(newColor);
    const updateColors = idx !== -1 ?
      filter.colors.filter((_:any, i:number) => i !== idx)
      : [...filter.colors, newColor]
    ;
    dispatch(PageActions.setFilter('colors', updateColors));
    dispatch(PagesToolbarActions.clearSelectedPages());
    forceVisible();
  }

  if ( trialMode ) return null;
  return (
    <ColorPalette activeColors={filter.colors}>
      {(color:string, idx:number) => (
        <ColorPalette.Item
          key={`filter-${color}-${idx}`}
          color={color}
          onClick={handleClick(color)}
        />
      )}
    </ColorPalette>
  )
}

export default ColorsPicker;
